import { ComponentRef } from  '@angular/core';

import { Observable, Subject } from 'rxjs';

import { ModalContainerComponent } from '../components/modal-container/modal-container.component';
import { Modal } from './Modal.model';

export class ModalRef {

    private result$ = new Subject<any>();

    constructor(
    private modalContainer: ComponentRef<ModalContainerComponent>,
    private modal: ComponentRef<Modal>,
    ) {
        this.modal.instance.modalInstance = this;
    }

    close(output: any): void {
        this.result$.next(this.modal.instance.getCloseResult(output));
        this.destroy$();
    }

    dismiss(): void {
        this.result$.error(null);
        this.destroy$();
    }

    private onResult(): Observable<any> {
        return this.result$.asObservable();
    }

    asPromise(): Promise<{ trigger: 'closed'|'dismissed'|'completed', confirmed: boolean, context?: any }> {
        return new Promise((resolve) => {
            this.onResult().subscribe(
                closed => resolve({ trigger: 'closed', confirmed: closed === 'confirmed', context: closed }),
                () => resolve({ trigger: 'dismissed', confirmed: false }),
                () => resolve({ trigger: 'completed', confirmed: false })
            )
        });
    }

    getModal(): ComponentRef<Modal> {
        return this.modal;
    }

    private destroy$(): void {
        this.modal.destroy();
        this.modalContainer.destroy();
        this.result$.complete();
    }

}